/* =========================================================================================================
   NJ: product card border on touch devices
   On desktop the border is shown on :hover (theme.css, ".product-card:hover"). On phones :hover only lasts while
   the finger is down, so the border disappeared as soon as a gallery swipe ended. Here, touching a card keeps its
   border (class "nj-card-touched", CSS in layout/theme.liquid) until the customer touches something else or
   scrolls further down/up the page.
   ========================================================================================================= */
(() => {
  'use strict';

  const ACTIVE_CLASS = 'nj-card-touched';
  const SCROLL_TOLERANCE = 60; // px of page scroll before the border is removed

  let activeCard = null;
  let scrollStart = 0;

  const clear = () => {
    if (activeCard) activeCard.classList.remove(ACTIVE_CLASS);
    activeCard = null;
  };

  document.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;

    const card = event.target.closest && event.target.closest('.product-card');
    if (card === activeCard) {
      scrollStart = window.scrollY;
      return;
    }

    clear();

    if (card) {
      activeCard = card;
      scrollStart = window.scrollY;
      card.classList.add(ACTIVE_CLASS);
    }
  }, { capture: true, passive: true });

  window.addEventListener('scroll', () => {
    if (activeCard && Math.abs(window.scrollY - scrollStart) > SCROLL_TOLERANCE) clear();
  }, { passive: true });

  // Coming back to the page with the back button (bfcache): start without a border
  window.addEventListener('pageshow', clear);
})();
